'use client'

import { useHotkeys } from "@/components/lib/shadcn-hooks-compat";
import { useColorScheme } from "@/components/lib/shadcn-core-compat";

export default function ThemeHotkey() {
    const colorScheme = useColorScheme();

    useHotkeys([
        ['mod+J', () => colorScheme.toggleColorScheme()],
    ]);

    return null;
}
